<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" i18n="@@CreatePricingHeader">
      Blackbox einrichten
    </h5>

    <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="onCancelClick()"></button>
  </div>
  
  <div class="modal-progress" [class]="'step-' + step">
    <a *ngFor="let caption of stepCaptions; index as i"
      (click)="step = i + 1"
      [class]="
        step < i + 1
        ? 'todo'
        : step == i + 1
        ? 'doing'
        : 'done'
        + (
          i == 1 && step > 2 && !blackboxSetupComponent.isCustomerDone
          ? ' missing'
          : ''
        )
        + (
          i == 2 && step > 3 && !blackboxSetupComponent.isAddressDone
          ? ' missing'
          : ''
        )">
      {{ caption }}
    </a>
  </div>

  <div class="modal-body" style="padding: 0;">
    <blackbox-setup [step]="step" (stepping)="setStep($event)" [serialNumber]="blackboxSerialNumber"></blackbox-setup>
  </div>

  <div class="modal-footer">
    <button type="button" id="cancel" class="btn btn-yellow mr-auto" data-bs-dismiss="modal" (click)="close()"
      i18n="@@CancelButton">
      <app-svg source="icons/feather/x" height="18"></app-svg>
      <span class="d-none d-md-inline pl-2">Schließen</span>
    </button>

    <button type="button" id="cancel" class="btn btn-yellow" data-bs-dismiss="modal" (click)="previousStep()"
      i18n="@@CancelButton" *ngIf="step > 1">
      <app-svg source="icons/feather/arrow-left" height="18"></app-svg>
      <span class="d-none d-md-inline pl-2">Zurück</span>
    </button>

    <button type="button" id="cancel" class="btn btn-yellow" data-bs-dismiss="modal" (click)="nextStep()"
      i18n="@@CancelButton" *ngIf="step < 6">
      <span class="d-none d-md-inline pr-2">Weiter</span>
      <app-svg source="icons/feather/arrow-right" height="18"></app-svg>
    </button>

    <form (ngSubmit)="blackboxSetupComponent.onSubmit()" *ngIf="step == 6">
      <button type="submit" id="add" class="btn btn-primary" i18n="@@AddButton" [disabled]="
          this.blackboxSetupComponent.formService.form.get('energyMeters').length < 1
          || !this.blackboxSetupComponent.isCustomerDone
          || !this.blackboxSetupComponent.isAddressDone
        ">
        <span class="d-none d-md-inline pr-2">Einrichtung abschließen</span>
        <app-svg source="icons/feather/check" height="18"></app-svg>
      </button>
    </form>
  </div>
</div>
